export default "{\n    \"defaultSubmitLabel\": \"Enregistrer\"\n}\n"